export default {
  linearRegressionHeadline: 'Linear regression',
  ployfit: {
    headline: 'Polynomial fit',
    degree: 'Degree',
  },
};
